import * as React from 'react';

import {Checkbox as CheckboxShell} from 'shells/checkbox/checkbox';

import styles from './checkbox.module.css';

type Props = {
    checked: boolean;
    label: string;
    hasError?: boolean;
    disabled?: boolean;
    onChange: (checked: boolean, arg2: React.ChangeEvent<HTMLInputElement>) => void;
};

export class Checkbox extends React.PureComponent<Props> {
    render() {
        return (
            <div className={styles.checkbox}>
                <CheckboxShell
                    isLarge={true}
                    onChange={this.props.onChange}
                    label={this.props.label}
                    checked={this.props.checked}
                    hasError={this.props.hasError}
                    disabled={this.props.disabled}
                />
            </div>
        );
    }
}
